// extracted by mini-css-extract-plugin
export default {"blockCodeHeader":"styles--blockCodeHeader--2z0Kl","copyButton":"styles--copyButton--EvKI5","copyIcon":"styles--copyIcon--1BuZP"};